var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row comms-history" }, [
    _vm.loading
      ? _c("p", { staticClass: "loading-text" }, [
          _vm._v("\n    Generating data...\n  "),
        ])
      : _c(
          "div",
          { staticClass: "col-lg-12 lbv-event-history" },
          [
            _c(
              "b-card",
              { attrs: { header: "Communications" } },
              [
                _c("b-table", {
                  attrs: {
                    items: _vm.commsHistoryItems,
                    fields: _vm.testCommsHistoryFields,
                    "sort-compare": _vm.commsEventCustomSort,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "id",
                      fn: function (row) {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm", variant: "primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.showModal(
                                    row.item,
                                    row.index,
                                    $event.target
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            View\n          ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.showPagination
                  ? _c(
                      "div",
                      { staticClass: "pagination" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "page prev",
                            attrs: {
                              variant: "primary",
                              size: "sm",
                              disabled: _vm.pageNumber === 1,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.page.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("\n          Prev\n        ")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "current-page" }, [
                          _vm._v(
                            "\n          Page: " +
                              _vm._s(_vm.pageNumber) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "page next",
                            attrs: {
                              variant: "primary",
                              size: "sm",
                              disabled: !_vm.hasNextPage,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.page.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("\n          Next\n        ")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: {
                  id: "modalInfo",
                  title: _vm.modalInfo.title,
                  "ok-only": "",
                },
                on: { hide: _vm.resetModal },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "modal-header" },
                    slot: "modal-header",
                  },
                  [
                    _c("span", { staticClass: "head-section" }, [
                      _vm._v(_vm._s(_vm.modalInfo.commEvent)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "head-section" }, [
                      _vm._v(_vm._s(_vm.modalInfo.commType) + " "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "head-section" }, [
                      _vm._v(_vm._s(_vm.modalInfo.date) + " "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "head-section" }, [
                      _vm._v(_vm._s(_vm.modalInfo.commSubject)),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "email-body",
                  domProps: { innerHTML: _vm._s(_vm.modalInfo.content) },
                }),
              ]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }